export interface SetNurtureArgs {
  leadId: string;
  active: boolean;
  note: string;
}

/**
 * The arguments for saving a nurture NOTE, as opposed to toggling nurture.
 *
 * This exists as its own function for one reason: `active` is the whole bug.
 *
 * The original defect was that the only writer of the note lived inside the
 * toggle, which while active sends `active: false` under a button reading
 * "Take out of nurture" — so saving the words ended the nurture. The fix is a
 * second writer that passes `active: true`, and a single wrong word here
 * recreates the original bug exactly.
 *
 * Tested through a component, that word is invisible: a panel rendered with
 * mocked callbacks cannot see what the callback then sends. Measured, not
 * assumed — a sabotage flipping it to `false` passed all 341 tracker tests.
 * So the argument comes out here where it can be asserted, the same way
 * `orderFromDealArgs` was extracted in 6c after a sabotage passed for the same
 * reason.
 */
export function nurtureNoteArgs(leadId: string, note: string): SetNurtureArgs {
  return { leadId, active: true, note };
}

/**
 * The arguments for the toggle, which is a different act with a different
 * consequence: taking a lead out of nurture clears the note by design, since
 * the note explains why they were in it.
 */
export function nurtureToggleArgs(leadId: string, next: boolean, note: string): SetNurtureArgs {
  return { leadId, active: next, note };
}
